import { Switch, styled } from '@mui/material';

export const StyledSwitch = styled(Switch)(() => ({
  '& .MuiSwitch-switchBase': {
    '&.Mui-checked': {
      color: '#4CAF50',
      '& + .MuiSwitch-track': {
        backgroundColor: '#4CAF50',
      },
    },
  },
}));
